import styles from "./styles.module.css";
import {PagegrowlerFunctions} from "@pagegrowler_nextjs";


const AdemasTenes = (props) => {
  const CLIPPING = "1_1_S2";
  const { title = "Además tenes que leer: " } = props;
  const pagegrowlerFunctions = PagegrowlerFunctions();


  return (
    <>
      {props.content && props.content.length > 0 && (
        <div className={`${styles["ademas-tenes-container"]}`}>
          <div className={`${styles["ademas-tenes-title"]}`}>{title}</div>
          {props.content.map((element, id) => {
            const { url, title } = element;
            let elementImages = {
              images: [
                  element.images[0] && element.images[0].value &&
                      {
                          clippings:  element.images[0].value.clippings ? element.images[0].value.clippings : [],
                          title: element.images[0].value.title ? element.images[0].value.title : ''
                      }
              ]
            };
            const img = pagegrowlerFunctions.getFullImageObject(elementImages, CLIPPING, process.env.NEXT_PUBLIC_IMAGE_DOMAIN);
					  const {url : src, title : alt, width, height} = img;
            
            return (
              <div
                key={element + id}
                className={`${styles["ademas-tenes-img-title-container"]}`}
              >
                <div className={`${styles["ademas-tenes-img"]}`}>
                  <a href={url}>
                    <img src={src} alt={alt} width={width} height={height} loading="lazy"/>
                  </a>
                </div>
                <div className={`${styles["ademas-tenes-text"]}`}>
                  <a href={url}> {title} </a>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default AdemasTenes;
